<div class="bom-comment-form">
  <gc-input-field
    [label]="'installationReportV2.orderOverviewTab.comment' | translate"
    [placeholder]="
      'installationReportV2.orderOverviewTab.commentPlaceholder' | translate
    "
    [value]="comment()"
    [renderTextArea]="true"
    [rows]="6"
    (changed)="onCommentChanged($event)"
  />
  <div class="actions">
    <gc-button
      [variant]="'primary'"
      [size]="'full'"
      [disabled]="!canConfirm()"
      [isLoading]="isSaving()"
      (clicked)="onConfirm()"
    >
      {{ 'installationReportV2.orderOverviewTab.save' | translate }}
    </gc-button>
    <gc-button
      [variant]="'secondary'"
      [size]="'full'"
      [disabled]="isSaving()"
      (clicked)="cancelled.emit()"
    >
      {{ 'installationReportV2.orderOverviewTab.cancel' | translate }}
    </gc-button>
  </div>
</div>
